import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { routes } from '../../routes';

const Register = lazy(() => import('./register'));
const SingIn = lazy(() => import('./singIn/SingInPage'));
const ForgotPassword = lazy(() => import('./forgotPassword/ForgotPasswordPage'));
const ConfirmPasswordRecovery = lazy(() => import('./confirmPasswordRecovery'));
const ChangePasswordPage = lazy(() => import('./changePassword'));
const DropOut = lazy(() => import('./dropOut/DropOutPage'));
const SuccessUnsubscribePage = lazy(() => import('./SuccessUnsubscribe/SuccessUnsubscribePage'));

export const userRoutes: RouteObject[] = [
  { path: `${routes.NEW_PASSWORD}/:token`, element: <ConfirmPasswordRecovery /> },
  { path: routes.REGISTER, element: <Register /> },
  { path: routes.LOGIN, element: <SingIn /> },
  { path: routes.CHANGE_PASSWORD, element: <ChangePasswordPage /> },
  { path: routes.FORGOT_PASSWORD, element: <ForgotPassword /> },
  { path: routes.DROP_OUT, element: <DropOut /> },
  { path: routes.SUCCESS_UNSUBSCRIBE, element: <SuccessUnsubscribePage /> },
];
